/**
 * Отказы ручки создания аккаунта — человеческим языком.
 *
 * Разводим по коду в теле (`error`), а не по подстроке в тексте: раньше
 * здесь стояла проверка `message.includes('409')`, и любой другой
 * конфликт — например «по этой заявке клиент уже заведён» — читался как
 * «номер занят». Менеджер шёл менять телефон вместо того, чтобы открыть
 * уже созданную клинику.
 *
 * Про `application_already_converted`: бэк присылает рядом `clinicId`,
 * но ссылку по нему мы пока дать не можем — карточка клиента
 * открывается только из списка, маршрута по id у неё нет. Поэтому
 * говорим, что делать, а не делаем вид, что ведём туда: пустой
 * результат поиска хуже честной подсказки.
 *
 * Случай этот редкий. Обычный повтор приходит как
 * `phone_already_used`: телефон бэк проверяет раньше заявки, и у двух
 * менеджеров, заводящих клиента по одной заявке, номер владельца
 * совпадает. До `application_already_converted` дело доходит, только
 * если номер в форме перед отправкой поменяли руками.
 */

import {getErrorCode, getErrorString} from '@utils/httpError';

/** Сколько мест предлагаем по умолчанию — из заявки это число не выводится. */
export const DEFAULT_SEATS = 5;

const TEXT: Record<string, string> = {
  phone_already_used: 'Этот номер уже используется другим клиентом',
  application_already_converted:
    'По этой заявке клиент уже заведён — закройте форму и откройте заявку заново',
  application_not_found: 'Заявка не найдена — возможно, её удалили',
};

export const createAccountFailure = (err: unknown): string => {
  const code = getErrorCode(err);
  return (
    (code !== null ? TEXT[code] : undefined) ??
    /* Незнакомый код — берём текст бэка, он написан для человека.
       Сам код в плашку не выводим: «application_not_found» менеджеру
       ничего не говорит, а общая фраза хотя бы читается. */
    getErrorString(err, 'message') ??
    'Не удалось создать аккаунт. Попробуйте ещё раз'
  );
};
